import dataPeriods from '../../utils/dataPeriods';

const offsetCalculatorReusableGraphConfig = {
  graphLegendTitle: 'Loan balances',
  graphLegendYearIndication: true,
  dataKeys: [
    {
      title: 'With offset',
      dataKey: 'balanceOffset',
    },
    {
      title: 'Without offset',
      dataKey: 'balance'
    }
  ],
  periodsKey: 'year',
  sourceDataPeriods: dataPeriods.YEARLY,
}

export default offsetCalculatorReusableGraphConfig;
